export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || "65a5f54e-fd4c-421a-8182-4b9a09966041",
    authority: process.env.REACT_APP_AZURE_AUTHORITY || "https://login.microsoftonline.com/c29154f3-766b-4c7f-9bd3-2a3b67573661",
    redirectUri: process.env.REACT_APP_REDIRECT_URI || "http://localhost:3001/calendar",
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  }
};

export const loginRequest = {
  scopes: ["openid", "profile", "email"]
};

export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};